(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section') || document.querySelector('.section-header') || this;
      this.headerIsAlwaysSticky = true;
      this.stickyType = 'always';

      if (this.header) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (!this.header || this.headerIsAlwaysSticky) return;

      const headerHeight = this.header.offsetHeight || 80;

      if (scrollTop > headerHeight) {
        this.header.classList.add('scrolled-past-header');

        if (scrollTop > this.currentScrollTop && scrollTop > headerHeight * 1.5) {
          // Scrolling down -> Hide
          if (!this.preventReveal) {
            this.header.classList.add('shopify-section-header-hidden');
            this.header.classList.add('animate');
          }
        } else if (scrollTop < this.currentScrollTop) {
          // Scrolling up -> Reveal
          this.header.classList.remove('shopify-section-header-hidden');
          this.header.classList.add('animate');
        }
      } else {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'animate');
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  // Scroll shadow fallback
  window.addEventListener('scroll', function() {
    var headerWrap = document.querySelector('.header-wrapper');
    if (headerWrap) {
      if (window.pageYOffset > 10) {
        headerWrap.classList.add('is-scrolled');
      } else {
        headerWrap.classList.remove('is-scrolled');
      }
    }
  }, { passive: true });
/* Desktop navigation: hover opens both the top menu and nested groups.
     Keep links as real anchors and let the carets toggle by click/keyboard. */
function initDesktopMenuHover(root = document) {
  const desktop = window.matchMedia('(min-width: 990px)');
  const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.header__center .list-menu--inline > li > header-menu > details, .header__center details.header__mega-menu-toggle';

  root.querySelectorAll(selector).forEach(function(details) {
    if (details.dataset.desktopHoverBound) return;
    details.dataset.desktopHoverBound = 'true';
    const summary = details.querySelector(':scope > summary');
    const nested = details.classList.contains('header__mega-menu-toggle');
    const region = nested ? details : details.closest('li');
    if (!summary || !region) return;
    let closeTimer;

    function setOpen(open) {
      details.open = open;
      summary.setAttribute('aria-expanded', String(open));
      if (!open) {
        details.querySelectorAll('details[open]').forEach(function(child) {
          child.open = false;
          const childSummary = child.querySelector(':scope > summary');
          if (childSummary) childSummary.setAttribute('aria-expanded', 'false');
        });
      }
    }

    function openMenu() {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      // Close peers, while preserving the parent mega menu.
      const parent = nested ? details.closest('ul') : region.parentElement;
      if (parent) {
        parent.querySelectorAll(selector).forEach(function(peer) {
          if (peer !== details && !peer.contains(details) && !details.contains(peer)) {
            peer.open = false;
            const peerSummary = peer.querySelector(':scope > summary');
            if (peerSummary) peerSummary.setAttribute('aria-expanded', 'false');
          }
        });
      }
      setOpen(true);
    }

    region.addEventListener('mouseenter', function() {
      if (hoverPointer.matches) openMenu();
    });
    region.addEventListener('mouseleave', function() {
      if (!desktop.matches || !hoverPointer.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function() {
        if (!region.matches(':hover') && !region.contains(document.activeElement)) setOpen(false);
      }, 220);
    });
    region.addEventListener('focusin', openMenu);
    region.addEventListener('focusout', function(event) {
      if (!region.contains(event.relatedTarget)) {
        clearTimeout(closeTimer);
        setOpen(false);
      }
    });

    // Capture prevents theme summary click handlers from cancelling the link.
    // Do not preventDefault: the browser must follow the anchor's real href.
    summary.addEventListener('click', function(event) {
      if (event.target.closest('a.header__parent-menu-link')) event.stopPropagation();
    }, true);
    details.addEventListener('toggle', function() {
      summary.setAttribute('aria-expanded', String(details.open));
    });
    details.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        clearTimeout(closeTimer);
        summary.focus();
        setOpen(false);
      }
    });
    summary.setAttribute('aria-expanded', String(details.open));
  });
}

// Count only rendered options, after any Liquid/Locksmith filtering.
function initHeaderShowMore(root = document) {
  const selector = '.header__center .header__submenu, .header__center .header__mega-menu-links, .header__center .header__mega-menu-sublinks, .header__mobile-drawer .menu-drawer__submenu .menu-drawer__menu';
  root.querySelectorAll(selector).forEach(function(list) {
    if (list.dataset.showMoreBound) return;
    list.dataset.showMoreBound = 'true';
    const items = Array.from(list.children).filter(function(item) {
      return item.tagName === 'LI';
    });
    if (items.length <= 10) return;

    if (!list.id) {
      let index = 1;
      while (document.getElementById('HeaderMenu-ShowMoreList-' + index)) index++;
      list.id = 'HeaderMenu-ShowMoreList-' + index;
    }
    const extraItems = items.slice(10);
    const row = document.createElement('li');
    row.className = 'header__show-more-row';
    row.setAttribute('role', 'presentation');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'header__show-more-button';
    button.setAttribute('aria-controls', list.id);
    row.appendChild(button);
    list.appendChild(row);

    function setExpanded(expanded) {
      // Return focus before hiding a focused descendant (for programmatic changes).
      if (!expanded && extraItems.some(function(item) { return item.contains(document.activeElement); })) {
        button.focus();
      }
      extraItems.forEach(function(item) {
        item.classList.toggle('header__show-more-hidden', !expanded);
        if (!expanded) {
          item.querySelectorAll('details[open]').forEach(function(details) {
            details.open = false;
            const summary = details.querySelector(':scope > summary');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          });
        }
      });
      button.textContent = expanded ? 'Show less' : 'Show more';
      button.setAttribute('aria-expanded', String(expanded));
    }
    button.addEventListener('click', function(event) {
      // Dawn binds drawer buttons as Back controls. Handle this disclosure first.
      event.stopImmediatePropagation();
      setExpanded(button.getAttribute('aria-expanded') !== 'true');
    }, true);
    setExpanded(false);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initDesktopMenuHover(); initHeaderShowMore(); });
} else {
  initDesktopMenuHover();
  initHeaderShowMore();
}
document.addEventListener('shopify:section:load', function(event) {
  initDesktopMenuHover(event.target);
  initHeaderShowMore(event.target);
});

  } catch(e) { console.error(e); }
})();
})();
